@import (reference) '../../../../../../constants/spacing.module.less';

.section {
  background: var(--light--background-color--1);
  border: solid 1px var(--default--border-color--12);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: @space-24;
  width: 100%;
}

.section-header {
  flex: 1;
  display: flex;
  align-items: center;
  height: 57px;
  cursor: pointer;
}

.title {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.section-content {
  padding: @space-16;
}

.header-text-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.header-price {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: @space-16;
}

.header-selected-state-label {
  font-style: italic;
}
